/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/**
 * Represents an item for comparison.
 */
export abstract class ComparisonItem<ItemId> {
    public readonly addedDate: Date;

    public readonly itemId: ItemId;

    public constructor(itemId: ItemId) {
        this.itemId = itemId;
        this.addedDate = new Date();
    }
}
